export default __webpack_public_path__ + "static/lexus_grey-465b6771bad957540a52d0889f15e6dd.jpg";